// extracted by mini-css-extract-plugin
export default {"loadingWraaper":"loadingWrapper_loadingWraaper__RVhwn"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"loadingWraaper\":\"loadingWrapper_loadingWraaper__RVhwn\"}";
        // 1793760839603
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  